import React, {useEffect, useState} from 'react';
import {Navigate, Link} from 'react-router-dom';
import {Button, Form, Input, Typography, Divider, Space, message} from 'antd';
import {doSignInWithEmailAndPassword, doSignInWithGoogle, doSignUpWithGoogle} from '../../../service/auth';
import {useAuth} from '../../../contexts/authContext';
import {FcGoogle} from "react-icons/fc";

const {Title, Text} = Typography;

const Login = () => {
    const {userLoggedIn} = useAuth();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSigningIn, setIsSigningIn] = useState(false);
    const [googleLoading, setGoogleLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [lastOpenedPage, setLastOpenedPage] = useState('');


    useEffect(() => {
        document.title = 'Login - CV Postman App';

        const lastOpenedPage = localStorage.getItem('lastOpenedPage');

        if (lastOpenedPage) {
            setLastOpenedPage(lastOpenedPage);
        } else {
            setLastOpenedPage('/onboarding');
        }

    }, []);

    const onSubmit = async () => {
        if (!isSigningIn) {
            setIsSigningIn(true);
            try {
                await doSignInWithEmailAndPassword(email, password);
            } catch (err) {
                setErrorMessage(err.message);
                setIsSigningIn(false);
            }
        }
    };

    const handleGoogleSignIn = async () => {
        setGoogleLoading(true);
        try {
            let result = await doSignUpWithGoogle();
            if (result?.user?.email) {
                // message.success('Google sign-in successful! 🎉');
            } else {
                message.error(result?.error);
            }
        } catch (error) {
            message.error(error.message);
        } finally {
            setGoogleLoading(false);
        }
    };

    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh'}}>
            {userLoggedIn && <Navigate to={lastOpenedPage}/>}

            <div style={{width: 400, padding: 24, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: 8}}>
                <Title level={3} style={{textAlign: 'center', marginBottom: 16}}>
                    Welcome Back
                </Title>
                <Form layout="vertical" onFinish={onSubmit}>
                    <Form.Item label="Email" name="email"
                               rules={[{required: true, message: 'Please enter your email!'}]}>
                        <Input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{required: true, message: 'Please enter your password!'}]}
                    >
                        <Input.Password
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                        />
                    </Form.Item>

                    {errorMessage && <Text type="danger">{errorMessage}</Text>}

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            loading={isSigningIn}
                            disabled={isSigningIn}
                        >
                            {isSigningIn ? 'Signing In...' : 'Sign In'}
                        </Button>
                    </Form.Item>
                    <Divider>OR</Divider>

                    <Form.Item>
                        <Button
                            icon={<FcGoogle size={20}/>}
                            type="default"
                            onClick={handleGoogleSignIn}
                            loading={googleLoading}
                            block
                        >
                            Sing In with Google
                        </Button>
                    </Form.Item>
                </Form>

                <Text style={{display: 'block', textAlign: 'center', marginBottom: 16}}>
                    Don't have an account? <Link to="/register">Sign up</Link>
                </Text>


            </div>
        </div>
    );
};

export default Login;
